/* eslint-disable */
/* tslint:disable */
/* Do not edit - generated by swagger-typescript-api */

import { ApplicationDataResponseCollectionResponse, ErrorResponse } from './data-contracts';
import { HttpClient, RequestParams } from './http-client';
export class ApplicationData<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;
  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }
  /**
   * No description
   *
   * @tags ApplicationData
   * @name ApplicationDataList
   * @request GET:/ApplicationData
   * @response `200` `ApplicationDataResponseCollectionResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  applicationDataList = (params: RequestParams = {}) =>
    this.http.request<ApplicationDataResponseCollectionResponse, ErrorResponse>({
      path: `/ApplicationData`,
      method: 'GET',
      format: 'json',
      ...params,
    });
}
